import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { NombrePep } from "../../models/NombrePep";
import { useForm } from "react-hook-form";
import { PepService } from "../../service/PepService";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Column } from "primereact/column";
import { useLazyParams } from "../../hooks/useLazyParams";
import { Menu } from "primereact/menu";
import { TablaDinamica } from "../../components/TablaDinamica";

export const Peps = () => {
    let fileRef = useRef(null);
    const toast = useRef(null);
    const menuRef = useRef(null);
    const generic = new GenericComponent();
    const omodel = new NombrePep();
    const pepService = new PepService();
    const [permss, setPermss] = useState(null);
    const [dialogPep, setDialogPep] = useState(false);
    const [dialogAdjunto, setDialogAdjunto] = useState(false);
    const [archivo, setArchivo] = useState(null);
    const [carga, setCarga] = useState(false);
    const [pepFila, setPepFila] = useState(null);
    const [selectedIns, setSelectedIns] = useState(null);
    const [ins, setIns] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { inDrop, inText, inNumber, inAutocomplete } = InputComponent({ omodel, errors, control, permss, id: getValues('id') });
    const tablaEstado = useLazyParams({ modelo: omodel.model });

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;

        if (permss == null) {
            _lazyParams.rtipo = true;
        }

        pepService.getPep({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);

            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
            if (res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
        }).catch(err => {
            generic.funcError(err, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setSelectedIns(null);
        setDialogPep(true);
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            pepService.newPep(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogPep(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            pepService.editarPep(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogPep(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editarPep = () => {
        pepService.consultarPep(pepFila.id).then(res => {
            let _inst = res.data;
            let lista = { estado: generic.estadosNum, tipo: catalogos?.tipo_identificacion };
            Object.keys(lista).forEach(function (key) {
                if (_inst[key] != null && lista[key]) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _inst[key]) {
                            _inst[key] = element;
                        }
                    });
                }
            });
            setSelectedIns(_inst.institucion);
            reset(generic.renewValues(_inst, omodel.model));
            setDialogPep(true);
        });
    }

    const nuevoPuesto = () => {
        pepService.consultarPep(pepFila.id).then(res => {
            let _inst = res.data;
            reset(defaultValues); // Limpia todo
            setValue('nombres', _inst.nombres);
            setValue('identificacion', _inst.identificacion);

            if (_inst.tipo && catalogos?.tipo_identificacion) {
                const _tipo = catalogos.tipo_identificacion.find(t => t.cat_id === _inst.tipo);
                setValue('tipo', _tipo);
            }
            setSelectedIns(null); // Debe elegir nueva institución
            setDialogPep(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: `¿Está seguro de eliminar a ${pepFila.nombres}?`,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                pepService.eliminarPep(pepFila.id).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const itemsMenu = () => {
        const items = [];
        items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editarPep() });
        items.push({ label: 'Nuevo Puesto (Clonar)', icon: 'pi pi-copy', command: () => nuevoPuesto() });
        items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                    onClick={(e) => { setPepFila(rowData); menuRef.current.toggle(e); }} />
            </div>
        );
    };

    const ColumnaAcciones = <Column header="Acciones" body={accionesTemplate} exportable={false} style={{ minWidth: '8rem', textAlign: 'center' }} />;

    const searchIns = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setIns([...(ins || [])]);
            } else {
                pepService.getInstituciones(event.query.toLowerCase()).then(data => {
                    setIns(data.data);
                });
            }
        });
    }

    const onSubmitFile = (data) => {
        if (archivo == null) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el archivo.', life: 3000 });
            return;
        }
        const formData = new FormData();
        formData.append('file', archivo);
        setCarga(true);
        pepService.procesar(formData).then(res => {
            setCarga(false);
            setArchivo(null);
            setDialogAdjunto(false);
            //generic.funcSuccess(res, toast);
            generic.downloadPdf(res.data, 'Resultados.xlsx');
        }).catch(error => {
            setCarga(false);
            generic.funcError(error, toast, setError);
        });
    }

    const invoiceUploadHandler = ({ files }) => {
        const [file] = files;
        const size = parseInt(process.env.REACT_APP_FILE_SIZE || 5242880);
        if (file.size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Tamaño máximo: ${size / 1024000} MB.`, life: 3000 });
        } else {
            setArchivo(file);
        }
        fileRef?.clear();
    }

    const selectFile = (e) => {
        const size = parseInt(process.env.REACT_APP_FILE_SIZE || 5242880);
        if (e.files.length <= 0) return;

        if (e.files[0].size > size) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Tamaño máximo: ${size / 1024000} MB.`, life: 3000 });
        } else {
            setArchivo(e.files[0]);
        }
        fileRef?.clear();
    }

    const leftToolbarTemplate = () => (
        <div className="flex gap-2">
            <Button label="Nuevo Registro" icon="pi pi-plus" className="p-button-success" onClick={openNew} />
            {permss?.crear && (<Button label="Procesar archivo" icon="pi pi-upload" className="p-button-primary" onClick={() => { setArchivo(null); setDialogAdjunto(true); }} />)}
        </div>
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_pep" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>

            <Dialog visible={dialogPep} header={getValues('id') == null ? "Nuevo Registro PEP" : "Editar Registro PEP"} modal className="p-fluid" onHide={() => setDialogPep(false)} style={{ maxWidth: '800px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {/* SECCIÓN OBLIGATORIA */}
                        <div className="col-12 mb-2"><h6 className="text-primary border-bottom-1 pb-2">Información Principal (Obligatoria)</h6></div>
                        {inText('nombres', { icon: 'pi pi-user' }, 12)}
                        {inAutocomplete('institucion', selectedIns, setSelectedIns, ins, searchIns, { lab: omodel.optionLabel, noEsActividad: true, col: 12 })}
                        {inText('puesto', { icon: 'pi pi-briefcase' }, 12)}
                        {inDrop('estado', generic.estadosNum, { lab: omodel.optionLabel }, 6)}
                        {/* SECCIÓN OPCIONAL */}
                        <div className="col-12 mt-4 mb-2"><h6 className="text-secondary border-bottom-1 pb-2">Información Complementaria (Opcional)</h6></div>
                        {inDrop('tipo', catalogos?.tipo_identificacion, { lab: omodel.optionLabel }, 6)}
                        {inText('identificacion', { icon: 'pi pi-id-card' }, 6)}
                        {inNumber('rmu_mensual', 2, true, { icon: 'pi pi-calendar' }, 6)}
                        {inNumber('rmu_anual', 2, true, { icon: 'pi pi-chart-bar' }, 6)}
                    </div>
                    <div className="flex justify-content-end gap-2 mt-4">
                        <Button label="Cancelar" icon="pi pi-times" type="button" severity="secondary" outlined onClick={() => setDialogPep(false)} />
                        <Button label="Guardar" icon="pi pi-save" type="submit" severity="warning" />
                    </div>
                </form>
            </Dialog>

            <Dialog visible={dialogAdjunto} header="Procesar archivo" modal className="p-fluid" onHide={() => setDialogAdjunto(false)} style={{ width: '450px' }}>
                <div className="surface-100 p-3 border-round mb-4 text-sm text-color-secondary">
                    <span className="font-bold block mb-2"><i className="pi pi-info-circle mr-2"></i>Instrucciones:</span>
                    <ul className="pl-3 m-0">
                        <li>1ra columna: Identificación.</li>
                        <li>2da columna: Nombre completo.</li>
                        <li>La primera fila debe contener los títulos.</li>
                        <li>Solo se procesará la primera hoja del Excel (.xlsx).</li>
                    </ul>
                </div>

                <div className="field col-12 text-center">
                    <FileUpload name="file" accept=".xlsx" maxFileSize={parseInt(process.env.REACT_APP_FILE_SIZE || 5242880)} uploadHandler={invoiceUploadHandler} mode="basic"
                        customUpload chooseLabel="Seleccione un archivo Excel" onSelect={selectFile} ref={ref => { fileRef = ref }} className="w-full" />
                    <div className="mt-3 font-semibold text-primary">{archivo?.name}</div>
                </div>

                <div className="flex justify-content-end gap-2 mt-3">
                    <Button label="Cerrar" icon="pi pi-times" outlined className="p-button-secondary" disabled={carga} onClick={() => setDialogAdjunto(false)} />
                    <Button label="Procesar" icon="pi pi-check" className="p-button-warning" loading={carga} onClick={onSubmitFile} />
                </div>
            </Dialog>
        </>
    )
}
